"use client"

import React, { createContext, useState, useEffect } from 'react';
import { createClient } from '@/utils/supabase/client';

const supabase = createClient();
export const UserContext = createContext(null);

export const UserProvider = ({ initialUser, children }) => {
  const [user, setUser] = useState(initialUser);
  useEffect(() => {
    //function to fetch full user data
    const fetchUserData = async () => {
      try {
        const response = await fetch('/api/getUser');
        if (!response.ok) {
          throw new Error('Failed to fetch user data');
        }
        const { user } = await response.json();
        setUser(user);
      } catch (error) {
        console.error('Error fetching user data:', error);
        setUser(null);
      }
    };
    //listens for auth state changes
    const { data: authListener } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
        fetchUserData();
      } else if (event === 'SIGNED_OUT') {
        setUser(null);
      }
    });
    //fetches user data on initial load if not already set
    if (!user) {
      fetchUserData();
    }

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};
